import ProspectForm from '@/components/prospect-form';

export default function ProspectFormEmailRenderer() {
  return <ProspectForm variant='email' />;
}
